import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const GorgiasTag = z.object({
  id: z.number(),
  name: z.string(),
  decoration: z.object({ color: z.string().nullish() }).nullish(),
  usage: z.number(),
  description: z.string().nullable(),
  uri: z.string(),
  created_datetime: z.string(),
  deleted_datetime: z.string().nullable(),
});

const GorgiasTagsResponse = z.object({
  object: z.literal("list"),
  uri: z.string(),
  data: z.array(GorgiasTag),
  meta: z.object({
    prev_cursor: z.string().nullable(),
    next_cursor: z.string().nullable(),
    total_resources: z.number().nullable(),
  }),
});

export const importGorgiasTags = {
  name: "importGorgiasTags" as const,
  input: z.object({
    teamId: zExt.objectId(),
    gorgiasTagsJson: GorgiasTagsResponse,
  }),
  output: z.object({
    success: z.boolean(),
    importedCount: z.number(),
    skippedCount: z.number(),
    errors: z.array(z.string()).optional(),
  }),
};
